import React from 'react';
import { getWorkshops } from '../../../utils/api';
import { ContentWrapper } from '../../../styles/shared';
import {
  Label,
  MainPagination,
  StyledHeader,
  StyledLink,
  TableStyled,
} from '../../news-archive/NewsArchive.style';
import {
  TableBody,
  TableBodyRow,
  TableBodyRowCell,
  TableHeader,
} from '../../../components/table/Table';
import Pagination from '../../../components/pagination/Pagination';
import PageSelect from '../../../components/page-select/PageSelect';
import { useRouter } from 'next/router';
import { Workshop } from '../../../models/auto-generated-strapi-types/types/Workshop';

interface WorkshopsTableProps {
  title?: string;
  paginationWorkshops: any;
  workshops: Workshop[];
}

const WorkshopsTable: React.FC<any> = ({
  data,
  translations,
}: {
  data: WorkshopsTableProps;
  translations: any;
}) => {
  const { title } = data;
  const router = useRouter();
  const [workshops, setWorkshops] = React.useState(data.workshops);

  const [page, setPage] = React.useState(data?.paginationWorkshops?.page || 1);
  const [pageSize, setPageSize] = React.useState(
    data?.paginationWorkshops?.pageSize || 24
  );

  const onChangePage = (pageToChange: number): void => {
    if (page === pageToChange) return;
    getWorkshops({
      locale: router.locale,
      pageSize: pageSize,
      page: pageToChange,
      sort: ['date:desc'],
      datesFormat: translations?.date?.workshop?.format,
    }).then((workshops) => {
      setPage(pageToChange);
      setWorkshops(workshops.data);
      const { query } = router;
      delete query?.slug;

      router.push(
        {
          pathname: `/${translations?.urls?.workshops}`,
          query: { ...query, page: pageToChange },
        },
        {
          pathname: `/${translations?.urls?.workshops}`,
          query: { ...query, page: pageToChange },
        },
        { locale: router.locale, shallow: true }
      );
    });
  };

  const onChangePageSize = (size: number): void => {
    getWorkshops({
      locale: router.locale,
      pageSize: size,
      page,
      sort: ['date:desc'],
      datesFormat: translations?.date?.newsArchive?.format,
    }).then((workshops) => {
      if (parseInt(page, 10) > workshops?.meta?.pagination?.pageCount) return;
      setPageSize(size);
      setWorkshops(workshops.data);
      const { query } = router;
      delete query?.slug;
      router.push(
        {
          pathname: `/${translations?.urls?.workshops}`,
          query: { ...query, pageSize: size },
        },
        {
          pathname: `/${translations?.urls?.workshops}`,
          query: { ...query, pageSize: size },
        },
        { locale: router.locale, shallow: true }
      );
    });
  };

  const goToWorkshop = (row: any, e: any): void => {
    e?.preventDefault?.();
    router.push(`/${translations?.urls?.workshops}/${row?.attributes?.slug}`);
  };

  if (workshops)
    return (
      <ContentWrapper>
        {title && <StyledHeader>{title}</StyledHeader>}
        <TableStyled>
          <TableHeader
            data={[
              translations?.pages?.workshops?.title,
              translations?.pages?.workshops?.date,
              '',
            ]}
          />
          <TableBody>
            {workshops &&
              workshops?.map((row, index) => {
                return (
                  <TableBodyRow
                    key={index}
                    onClick={(e: any) => goToWorkshop(row, e)}
                  >
                    <TableBodyRowCell>
                      {row?.attributes?.title ?? ''}
                    </TableBodyRowCell>
                    <TableBodyRowCell>
                      {row?.attributes?.date ?? 'N/A'}
                    </TableBodyRowCell>
                    <TableBodyRowCell>
                      <StyledLink
                        onClick={(e: any) => goToWorkshop(row, e)}
                        href={`/${
                          translations?.urls?.workshops
                        }/${encodeURIComponent(
                          row?.attributes?.title
                            ?.toLowerCase()
                            ?.replace(/\s/g, '-')
                        )}-${row?.id}`}
                      >
                        {translations?.pages?.workshops?.goToWorkshop}
                      </StyledLink>
                    </TableBodyRowCell>
                  </TableBodyRow>
                );
              })}
          </TableBody>
        </TableStyled>
        {workshops.length > 0 && (
          <MainPagination>
            <Pagination
              count={Math.ceil(data?.paginationWorkshops?.total / pageSize)}
              page={page}
              onChangePage={onChangePage}
            ></Pagination>
            <div>
              <Label>
                {
                  translations?.pages?.category?.main?.products?.pagination
                    ?.label
                }
              </Label>
              <PageSelect
                currentValue={pageSize}
                onChangePageSize={onChangePageSize}
              />
            </div>
          </MainPagination>
        )}
      </ContentWrapper>
    );
  else return <></>;
};

export default WorkshopsTable;
